export class CustomError extends Error {
  status: number;
  logOnly: boolean;
  constructor(message: string, status:number, logOnly:boolean) {
    super(message); // (1)
    this.name = "CustomError"; // (2)
    this.status = status;
    this.logOnly = logOnly;
  }
}